import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import queryString from 'query-string-for-all';
import productCollectionPageQuery from './query.graphql';

const ProductCollection = loadable(
  () =>
    import(/* webpackChunkName: "product-collection" */ './product-collection'),
  {
    fallback: <Loader />,
  }
);

ProductCollection.graphQL = productCollectionPageQuery;

// TODO: once we decide how to go about product collection SSR state, we can remove this as well
ProductCollection.ssr = ({ state = { aggregations: [] }, location }) => {
  const { offset, sort, direction } = queryString.parse(location.search);
  return {
    ...state,
    offset: parseInt(offset, 10) || 0,
    sort,
    direction,
    url: location.pathname + location.search, // Use url to construct new filters server side
    filters: [],
  };
};

ProductCollection.variables = ({ id, slug, productPropertyIds }) => ({
  id,
  slug,
  productPropertyIds,
});

ProductCollection.stateToVariables = state => {
  return {
    query: {
      url: state.url,
      // if the url is set, somewhere we extract the filters from the url
      filters: !state.url && state.filters ? state.filters : undefined,
      aggregations: state.aggregations,
      sort: state.sort,
      direction: state.direction,
      offset: state.offset,
      globalPropertySearch: state.globalPropertySearch,
    },
    productPropertyIds: state.propertyColumnIds?.filter(
      // SIMULATED_PROPERTY_COLUMNS
      column => !['brand'].includes(column)
    ),
    productPropertyColumnIds: state.propertyColumnIds,
  };
};

export default ProductCollection;
